import React, { useMemo, useState } from "react";
import {
  FaCalendarAlt,
  FaClock,
  FaFilter,
  FaLayerGroup,
  FaMapMarkerAlt,
  FaRegCalendarCheck,
} from "react-icons/fa";

import { FaRotateLeft } from "react-icons/fa6";

import Reveal from "../../../components/Reveal/Reveal";

/* ==========================================================================
   JOURS
   ========================================================================== */

const DAY_LABELS = [
  "Lundi",
  "Mardi",
  "Mercredi",
  "Jeudi",
  "Vendredi",
  "Samedi",
  "Dimanche",
];

/* ==========================================================================
   DOJO
   ========================================================================== */

const DOJO_OPTIONS = [
  {
    id: "david-douillet",
    label: "David Douillet",
    fullName: "Gymnase David Douillet",
    address: "Rue Gustave Charpentier 94240 L'Haÿ-les-Roses",
  },
  {
    id: "arnaud-beltrame",
    label: "Arnaud Beltrame",
    fullName: "Gymnase Arnaud Beltrame",
    address: "16, rue Pierre Kohlmann 92160 Antony",
  },
  {
    id: "vallee-aux-renards",
    label: "Vallée aux Renards",
    fullName: "Gymnase la Vallée aux Renards",
    address: "24, rue Jean Moulin 94260 Fresnes",
  },
];

/* ==========================================================================
   DISCIPLINES
   ========================================================================== */

const DISCIPLINE_OPTIONS = [
  {
    id: "judo",
    label: "Judo",
  },
  {
    id: "jjb",
    label: "Jiu-Jitsu Brésilien",
  },
];

/* ==========================================================================
   PLANNING
   --------------------------------------------------------------------------
   On ne dépend volontairement PAS des groupes venant du serveur.
   ========================================================================== */

const COURSES = [
  /* ========================================================================
     DAVID DOUILLET - JUDO
     ======================================================================== */

  {
    id: "dd-bg1",
    dojoId: "david-douillet",
    discipline: "judo",
    day: "Mercredi",
    start: "13h45",
    end: "14h30",
    code: "L - BG 1",
    name: "Baby's et Galipettes",
    age: "Nés en 2023 - 2022",
    teacher: "",
    color: "orange",
  },

  {
    id: "dd-bj",
    dojoId: "david-douillet",
    discipline: "judo",
    day: "Mercredi",
    start: "14h30",
    end: "15h15",
    code: "L - BJ",
    name: "Baby's Judo",
    age: "Nés en 2022 - 2021",
    teacher: "",
    color: "orange",
  },

  {
    id: "dd-cop1",
    dojoId: "david-douillet",
    discipline: "judo",
    day: "Mercredi",
    start: "15h15",
    end: "16h15",
    code: "L - COP 1",
    name: "Coquilles et Poussins",
    age: "Nés entre 2017 et 2020",
    teacher: "",
    color: "orange",
  },

  {
    id: "dd-coq-lundi",
    dojoId: "david-douillet",
    discipline: "judo",
    day: "Lundi",
    start: "17h30",
    end: "18h30",
    code: "L - COQ",
    name: "Coquilles",
    age: "Nés en 2020 ou 2019",
    teacher: "",
    color: "emerald",
  },

  {
    id: "dd-pob-lundi",
    dojoId: "david-douillet",
    discipline: "judo",
    day: "Lundi",
    start: "18h30",
    end: "19h30",
    code: "L - POB",
    name: "Poussins et Benjamins",
    age: "Nés entre 2015 et 2018",
    teacher: "",
    color: "blue",
  },

  {
    id: "dd-coq-vendredi",
    dojoId: "david-douillet",
    discipline: "judo",
    day: "Vendredi",
    start: "17h30",
    end: "18h30",
    code: "L - COQ",
    name: "Coquilles",
    age: "Nés en 2020 ou 2019",
    teacher: "",
    color: "emerald",
  },

  {
    id: "dd-pob-vendredi",
    dojoId: "david-douillet",
    discipline: "judo",
    day: "Vendredi",
    start: "18h30",
    end: "19h30",
    code: "L - POB",
    name: "Poussins et Benjamins",
    age: "Nés entre 2015 et 2018",
    teacher: "",
    color: "blue",
  },

  {
    id: "dd-mcjs",
    dojoId: "david-douillet",
    discipline: "judo",
    day: "Vendredi",
    start: "19h30",
    end: "21h00",
    code: "MCJS",
    name: "Minimes, Cadets, Juniors, Seniors",
    age: "À partir de 2014",
    teacher: "",
    color: "purple",
  },

  {
    id: "dd-bg2",
    dojoId: "david-douillet",
    discipline: "judo",
    day: "Samedi",
    start: "09h00",
    end: "09h45",
    code: "L - BG 2",
    name: "Baby's et Galipettes",
    age: "Nés en 2023 - 2022",
    teacher: "",
    color: "orange",
  },

  {
    id: "dd-cop2",
    dojoId: "david-douillet",
    discipline: "judo",
    day: "Samedi",
    start: "09h45",
    end: "10h30",
    code: "L - COP 2",
    name: "Coquilles et Poussins",
    age: "Nés entre 2017 et 2020",
    teacher: "",
    color: "orange",
  },

  /* ========================================================================
     DAVID DOUILLET - JJB
     ======================================================================== */

  {
    id: "dd-jjb-enfants",
    dojoId: "david-douillet",
    discipline: "jjb",
    day: "Mercredi",
    start: "17h30",
    end: "18h30",
    code: "JJB ENFANTS",
    name: "Jiu-Jitsu Brésilien Enfants",
    age: "7 à 12 ans",
    teacher: "",
    color: "red",
  },

  {
    id: "dd-jjb-adultes",
    dojoId: "david-douillet",
    discipline: "jjb",
    day: "Mercredi",
    start: "18h30",
    end: "20h00",
    code: "JJB ADULTES",
    name: "Jiu-Jitsu Brésilien Adultes",
    age: "Adultes",
    teacher: "",
    color: "red",
  },

  /* ========================================================================
     ARNAUD BELTRAME - JUDO
     ======================================================================== */

  {
    id: "ab-pob-lundi",
    dojoId: "arnaud-beltrame",
    discipline: "judo",
    day: "Lundi",
    start: "18h00",
    end: "19h00",
    code: "A - POB",
    name: "Poussins et Benjamins",
    age: "Nés entre 2018 et 2015",
    teacher: "",
    color: "blue",
  },

  {
    id: "ab-cp",
    dojoId: "arnaud-beltrame",
    discipline: "judo",
    day: "Lundi",
    start: "19h00",
    end: "19h30",
    code: "A - CP",
    name: "Cours préparatoire aux UV",
    age: "Accessible dès ceinture marron",
    teacher: "",
    color: "slate",
  },

  {
    id: "ab-mcjs",
    dojoId: "arnaud-beltrame",
    discipline: "judo",
    day: "Lundi",
    start: "19h30",
    end: "21h00",
    code: "MCJS",
    name: "Minimes, Cadets, Juniors, Seniors",
    age: "À partir de 2014",
    teacher: "",
    color: "purple",
  },

  {
    id: "ab-bc",
    dojoId: "arnaud-beltrame",
    discipline: "judo",
    day: "Mercredi",
    start: "13h45",
    end: "14h45",
    code: "A - BC",
    name: "Baby's et Coquilles",
    age: "Nés en 2021 - 2019",
    teacher: "",
    color: "orange",
  },

  {
    id: "ab-coq-mercredi",
    dojoId: "arnaud-beltrame",
    discipline: "judo",
    day: "Mercredi",
    start: "13h45",
    end: "14h45",
    code: "A - COQ",
    name: "Coquilles",
    age: "Nés en 2020 ou 2019",
    teacher: "",
    color: "emerald",
  },

  {
    id: "ab-pob-mercredi",
    dojoId: "arnaud-beltrame",
    discipline: "judo",
    day: "Mercredi",
    start: "14h45",
    end: "15h45",
    code: "A - POB",
    name: "Poussins et Benjamins",
    age: "Nés entre 2018 et 2015",
    teacher: "",
    color: "blue",
  },

  {
    id: "ab-bg",
    dojoId: "arnaud-beltrame",
    discipline: "judo",
    day: "Samedi",
    start: "09h00",
    end: "09h45",
    code: "A - BG",
    name: "Baby's et Galipettes",
    age: "Nés en 2023 - 2022",
    teacher: "",
    color: "orange",
  },

  {
    id: "ab-bj1",
    dojoId: "arnaud-beltrame",
    discipline: "judo",
    day: "Samedi",
    start: "09h45",
    end: "10h30",
    code: "A - BJ 1",
    name: "Baby's Judo",
    age: "Nés en 2022 - 2021",
    teacher: "",
    color: "orange",
  },

  {
    id: "ab-bj2",
    dojoId: "arnaud-beltrame",
    discipline: "judo",
    day: "Samedi",
    start: "10h30",
    end: "11h15",
    code: "A - BJ 2",
    name: "Baby's Judo",
    age: "Nés en 2022 - 2021",
    teacher: "",
    color: "orange",
  },

  {
    id: "ab-coq-samedi",
    dojoId: "arnaud-beltrame",
    discipline: "judo",
    day: "Samedi",
    start: "11h15",
    end: "12h15",
    code: "A - COQ",
    name: "Coquilles",
    age: "Nés en 2020 ou 2019",
    teacher: "",
    color: "emerald",
  },

  /* ========================================================================
     VALLÉE AUX RENARDS - JUDO
     ======================================================================== */

  {
    id: "vr-coq-mardi",
    dojoId: "vallee-aux-renards",
    discipline: "judo",
    day: "Mardi",
    start: "17h00",
    end: "18h00",
    code: "V - COQ",
    name: "Coquilles",
    age: "Nés en 2020 ou 2019",
    teacher: "",
    color: "emerald",
  },

  {
    id: "vr-po-mardi",
    dojoId: "vallee-aux-renards",
    discipline: "judo",
    day: "Mardi",
    start: "18h00",
    end: "19h00",
    code: "V - PO",
    name: "Poussins",
    age: "Nés en 2018 ou 2017",
    teacher: "",
    color: "blue",
  },

  {
    id: "vr-ben-mardi",
    dojoId: "vallee-aux-renards",
    discipline: "judo",
    day: "Mardi",
    start: "19h00",
    end: "20h30",
    code: "V - BEN",
    name: "Benjamins",
    age: "Nés entre 2016 et 2015",
    teacher: "",
    color: "indigo",
  },

  {
    id: "vr-minimes-mardi",
    dojoId: "vallee-aux-renards",
    discipline: "judo",
    day: "Mardi",
    start: "19h00",
    end: "20h30",
    code: "V - M",
    name: "Minimes",
    age: "Nés entre 2014 et 2013",
    teacher: "",
    color: "purple",
  },

  {
    id: "vr-coq-vendredi",
    dojoId: "vallee-aux-renards",
    discipline: "judo",
    day: "Vendredi",
    start: "17h00",
    end: "18h00",
    code: "V - COQ",
    name: "Coquilles",
    age: "Nés en 2020 ou 2019",
    teacher: "",
    color: "emerald",
  },

  {
    id: "vr-po-vendredi",
    dojoId: "vallee-aux-renards",
    discipline: "judo",
    day: "Vendredi",
    start: "18h00",
    end: "19h00",
    code: "V - PO",
    name: "Poussins",
    age: "Nés en 2018 ou 2017",
    teacher: "",
    color: "blue",
  },

  {
    id: "vr-ben-vendredi",
    dojoId: "vallee-aux-renards",
    discipline: "judo",
    day: "Vendredi",
    start: "19h00",
    end: "20h30",
    code: "V - BEN",
    name: "Benjamins",
    age: "Nés entre 2016 et 2015",
    teacher: "",
    color: "indigo",
  },

  {
    id: "vr-minimes-vendredi",
    dojoId: "vallee-aux-renards",
    discipline: "judo",
    day: "Vendredi",
    start: "19h00",
    end: "20h30",
    code: "V - M",
    name: "Minimes",
    age: "Nés entre 2014 et 2013",
    teacher: "",
    color: "purple",
  },

  {
    id: "vr-bg",
    dojoId: "vallee-aux-renards",
    discipline: "judo",
    day: "Samedi",
    start: "11h00",
    end: "11h45",
    code: "V - BG",
    name: "Baby's et Galipettes",
    age: "Nés en 2023 - 2021",
    teacher: "",
    color: "orange",
  },

  /* ========================================================================
     VALLÉE AUX RENARDS - JJB
     ======================================================================== */

  {
    id: "vr-jjb-adultes-mardi",
    dojoId: "vallee-aux-renards",
    discipline: "jjb",
    day: "Mardi",
    start: "20h30",
    end: "22h00",
    code: "JJB ADULTES",
    name: "Jiu-Jitsu Brésilien Adultes",
    age: "Adultes",
    teacher: "",
    color: "red",
  },

  {
    id: "vr-jjb-adultes-jeudi",
    dojoId: "vallee-aux-renards",
    discipline: "jjb",
    day: "Jeudi",
    start: "20h00",
    end: "21h30",
    code: "JJB ADULTES",
    name: "Jiu-Jitsu Brésilien Adultes",
    age: "Adultes",
    teacher: "",
    color: "red",
  },

  {
    id: "vr-jjb-enfants-samedi",
    dojoId: "vallee-aux-renards",
    discipline: "jjb",
    day: "Samedi",
    start: "11h45",
    end: "12h30",
    code: "JJB ENFANTS",
    name: "Jiu-Jitsu Brésilien Enfants",
    age: "7 à 12 ans",
    teacher: "",
    color: "red",
  },

  {
    id: "vr-jjb-adultes-samedi",
    dojoId: "vallee-aux-renards",
    discipline: "jjb",
    day: "Samedi",
    start: "12h30",
    end: "14h00",
    code: "JJB ADULTES",
    name: "Jiu-Jitsu Brésilien Adultes",
    age: "Adultes",
    teacher: "",
    color: "red",
  },
];

/* ==========================================================================
   COULEURS
   ========================================================================== */

const COLOR_STYLES = {
  orange: {
    bar: "from-orange-500 to-amber-400",
    badge:
      "bg-orange-100 text-orange-800 dark:bg-orange-500/10 dark:text-orange-300",
  },

  emerald: {
    bar: "from-emerald-500 to-teal-400",
    badge:
      "bg-emerald-100 text-emerald-800 dark:bg-emerald-500/10 dark:text-emerald-300",
  },

  blue: {
    bar: "from-blue-500 to-sky-400",
    badge: "bg-blue-100 text-blue-800 dark:bg-blue-500/10 dark:text-blue-300",
  },

  indigo: {
    bar: "from-indigo-500 to-blue-400",
    badge:
      "bg-indigo-100 text-indigo-800 dark:bg-indigo-500/10 dark:text-indigo-300",
  },

  purple: {
    bar: "from-purple-500 to-fuchsia-400",
    badge:
      "bg-purple-100 text-purple-800 dark:bg-purple-500/10 dark:text-purple-300",
  },

  red: {
    bar: "from-red-500 to-rose-400",
    badge: "bg-red-100 text-red-800 dark:bg-red-500/10 dark:text-red-300",
  },

  slate: {
    bar: "from-slate-600 to-slate-400",
    badge: "bg-slate-100 text-slate-700 dark:bg-white/10 dark:text-slate-300",
  },
};

/* ==========================================================================
   HELPERS
   ========================================================================== */

function cn(...classes) {
  return classes.filter(Boolean).join(" ");
}

function timeToMinutes(value = "") {
  const match = String(value).match(/(\d{1,2})\s*(?:h|H|:)?\s*(\d{0,2})/);

  if (!match) {
    return 24 * 60 + 1;
  }

  const hours = Math.min(23, Math.max(0, parseInt(match[1], 10)));

  const minutes = match[2] ? Math.min(59, parseInt(match[2], 10)) : 0;

  return hours * 60 + minutes;
}

function getTodayLabel() {
  const jsDay = new Date().getDay();

  return DAY_LABELS[(jsDay + 6) % 7];
}

function getDojo(dojoId) {
  return DOJO_OPTIONS.find((dojo) => dojo.id === dojoId);
}

function getDiscipline(disciplineId) {
  return DISCIPLINE_OPTIONS.find(
    (discipline) => discipline.id === disciplineId,
  );
}

/* ==========================================================================
   FILTRES
   ========================================================================== */

function FilterButton({ active, children, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        "rounded-xl border px-4 py-2.5 text-sm font-bold transition",
        active
          ? "border-orange-400 bg-orange-500 text-white shadow-md shadow-orange-500/20"
          : "border-slate-200 bg-white text-slate-600 hover:border-orange-300 hover:text-orange-700 dark:border-white/10 dark:bg-slate-900 dark:text-slate-300 dark:hover:border-orange-500/30 dark:hover:text-orange-300",
      )}
    >
      {children}
    </button>
  );
}

/* ==========================================================================
   COURSE
   ========================================================================== */

function CourseItem({ course }) {
  const style = COLOR_STYLES[course.color] || COLOR_STYLES.orange;

  const dojo = getDojo(course.dojoId);

  const discipline = getDiscipline(course.discipline);

  return (
    <li className="group/course relative overflow-hidden rounded-[1.5rem] border border-slate-200 bg-white p-4 shadow-sm transition hover:-translate-y-1 hover:shadow-lg dark:border-white/10 dark:bg-slate-950">
      <div
        className={cn(
          "absolute inset-y-0 left-0 w-1.5 bg-gradient-to-b",
          style.bar,
        )}
      />

      <div className="pl-2">
        {/* HEADER */}

        <div className="flex flex-wrap items-start justify-between gap-3">
          <div className="min-w-0">
            <div className="flex flex-wrap items-center gap-2">
              <span
                className={cn(
                  "rounded-full px-2.5 py-1 text-[10px] font-black uppercase tracking-[0.13em]",
                  course.discipline === "jjb"
                    ? "bg-red-100 text-red-700 dark:bg-red-500/10 dark:text-red-300"
                    : "bg-slate-100 text-slate-600 dark:bg-white/10 dark:text-slate-300",
                )}
              >
                {discipline?.label}
              </span>

              {course.code && (
                <span className="text-xs font-bold text-slate-400">
                  {course.code}
                </span>
              )}
            </div>

            <h4 className="mt-2 font-barlow text-xl font-bold leading-tight text-slate-950 dark:text-white">
              {course.name}
            </h4>
          </div>

          {/* HEURE */}

          <span className="inline-flex shrink-0 items-center gap-2 rounded-full bg-slate-100 px-3 py-1.5 text-xs font-bold text-slate-600 dark:bg-white/10 dark:text-slate-300">
            <FaClock className="text-primary" />
            {course.start} – {course.end}
          </span>
        </div>

        {/* AGE */}

        {course.age && (
          <div className="mt-3">
            <span
              className={cn(
                "inline-flex rounded-full px-3 py-1 text-xs font-bold",
                style.badge,
              )}
            >
              {course.age}
            </span>
          </div>
        )}

        {/* DOJO */}

        <div className="mt-3 flex items-start gap-2 text-sm font-semibold text-slate-500 dark:text-slate-400">
          <FaMapMarkerAlt className="mt-1 shrink-0 text-primary" />

          <span>{dojo?.fullName}</span>
        </div>

        {/* PROF */}

        {course.teacher && (
          <p className="mt-2 text-sm font-semibold text-slate-500 dark:text-slate-400">
            {course.teacher}
          </p>
        )}
      </div>
    </li>
  );
}

/* ==========================================================================
   JOUR
   ========================================================================== */

function DayCard({ day, courses, isToday }) {
  return (
    <article
      className={cn(
        "relative overflow-hidden rounded-[2rem] border bg-white p-5 shadow-sm transition hover:shadow-xl dark:bg-slate-900",
        isToday
          ? "border-orange-300 ring-4 ring-orange-500/10 dark:border-orange-500/40"
          : "border-slate-200 dark:border-white/10",
      )}
    >
      <div className="mb-5 flex items-center justify-between gap-4">
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.18em] text-slate-400">
            Jour
          </p>

          <h3
            className={cn(
              "mt-1 font-barlow text-3xl font-bold",
              isToday ? "text-primary" : "text-slate-950 dark:text-white",
            )}
          >
            {day}
          </h3>
        </div>

        <div className="rounded-full bg-slate-100 px-3 py-1.5 text-xs font-bold text-slate-500 dark:bg-white/10 dark:text-slate-300">
          {courses.length} {courses.length > 1 ? "cours" : "cours"}
        </div>
      </div>

      {isToday && (
        <div className="mb-4 rounded-2xl bg-orange-100 px-4 py-2 text-sm font-bold text-orange-800 dark:bg-orange-500/10 dark:text-orange-300">
          Aujourd’hui
        </div>
      )}

      <ul className="space-y-3">
        {courses.map((course) => (
          <CourseItem key={course.id} course={course} />
        ))}
      </ul>
    </article>
  );
}

/* ==========================================================================
   EMPTY
   ========================================================================== */

function EmptyState() {
  return (
    <div className="col-span-full rounded-[2rem] border border-dashed border-slate-300 bg-white/75 p-10 text-center shadow-sm dark:border-white/10 dark:bg-white/5">
      <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-orange-100 text-primary dark:bg-orange-500/10">
        <FaRegCalendarCheck />
      </div>

      <h3 className="font-barlow text-2xl font-bold text-slate-950 dark:text-white">
        Aucun cours trouvé
      </h3>

      <p className="mx-auto mt-3 max-w-xl text-sm leading-6 text-slate-500 dark:text-slate-400">
        Aucun cours ne correspond aux filtres actuellement sélectionnés.
      </p>
    </div>
  );
}

/* ==========================================================================
   COMPOSANT PRINCIPAL
   ========================================================================== */

export default function WeeklySchedule() {
  const [selectedDojo, setSelectedDojo] = useState("all");

  const [selectedDiscipline, setSelectedDiscipline] = useState("all");

  /* ------------------------------------------------------------------------
     FILTRAGE
     ------------------------------------------------------------------------ */

  const filteredCourses = useMemo(() => {
    return COURSES.filter((course) => {
      const dojoMatches =
        selectedDojo === "all" || course.dojoId === selectedDojo;

      const disciplineMatches =
        selectedDiscipline === "all" ||
        course.discipline === selectedDiscipline;

      return dojoMatches && disciplineMatches;
    });
  }, [selectedDojo, selectedDiscipline]);

  /* ------------------------------------------------------------------------
     REGROUPEMENT PAR JOUR
     ------------------------------------------------------------------------ */

  const schedule = useMemo(() => {
    const result = {};

    filteredCourses.forEach((course) => {
      if (!result[course.day]) {
        result[course.day] = [];
      }

      result[course.day].push({
        ...course,
        startMin: timeToMinutes(course.start),
      });
    });

    Object.keys(result).forEach((day) => {
      result[day].sort((a, b) => a.startMin - b.startMin);
    });

    return result;
  }, [filteredCourses]);

  /* ------------------------------------------------------------------------
     JOURS AYANT DES COURS
     ------------------------------------------------------------------------ */

  const orderedDays = useMemo(() => {
    return DAY_LABELS.filter((day) => schedule[day]?.length > 0);
  }, [schedule]);

  const todayLabel = getTodayLabel();

  /* ------------------------------------------------------------------------
     RESET
     ------------------------------------------------------------------------ */

  const resetFilters = () => {
    setSelectedDojo("all");
    setSelectedDiscipline("all");
  };

  const hasActiveFilters =
    selectedDojo !== "all" || selectedDiscipline !== "all";

  return (
    <section className="relative overflow-hidden bg-slate-50 py-20 text-slate-950 dark:bg-slate-950 dark:text-white lg:py-28">
      {/* BACKGROUND */}

      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(242,113,49,0.12),transparent_34%),radial-gradient(circle_at_bottom_right,rgba(59,130,246,0.10),transparent_32%)]" />

      <div className="absolute inset-0 bg-[linear-gradient(to_right,rgba(148,163,184,0.13)_1px,transparent_1px),linear-gradient(to_bottom,rgba(148,163,184,0.13)_1px,transparent_1px)] bg-[size:42px_42px] opacity-35 dark:opacity-15" />

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {/* ================================================================ */}
        {/* TITRE                                                            */}
        {/* ================================================================ */}

        <Reveal className="mx-auto max-w-3xl text-center">
          <div className="inline-flex items-center gap-2 rounded-full border border-orange-200 bg-orange-50 px-4 py-2 text-xs font-bold uppercase tracking-[0.22em] text-orange-700 shadow-sm dark:border-orange-500/20 dark:bg-orange-500/10 dark:text-orange-300">
            <FaCalendarAlt />
            Planning hebdomadaire
          </div>

          <h2 className="mt-6 font-barlow text-4xl font-bold tracking-tight text-slate-950 dark:text-white sm:text-5xl lg:text-6xl">
            Planning <span className="text-primary">des cours</span>
          </h2>

          <p className="mx-auto mt-5 max-w-2xl text-base leading-8 text-slate-600 dark:text-slate-300">
            Retrouvez tous les cours de Judo et de Jiu-Jitsu Brésilien, classés
            par jour, dojo et discipline.
          </p>
        </Reveal>

        {/* ================================================================ */}
        {/* FILTRES                                                          */}
        {/* ================================================================ */}

        <Reveal className="mt-10" delay={100}>
          <div className="rounded-[2rem] border border-slate-200 bg-white/90 p-5 shadow-lg shadow-slate-900/5 backdrop-blur dark:border-white/10 dark:bg-slate-900/90">
            {/* HEADER FILTRES */}

            <div className="flex flex-wrap items-center justify-between gap-3">
              <div className="flex items-center gap-2">
                <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-orange-100 text-primary dark:bg-orange-500/10">
                  <FaFilter />
                </div>

                <div>
                  <p className="font-barlow text-lg font-bold text-slate-950 dark:text-white">
                    Filtrer le planning
                  </p>

                  <p className="text-xs text-slate-500 dark:text-slate-400">
                    Dojo et discipline
                  </p>
                </div>
              </div>

              {hasActiveFilters && (
                <button
                  type="button"
                  onClick={resetFilters}
                  className="inline-flex items-center gap-2 rounded-xl px-3 py-2 text-sm font-bold text-slate-500 transition hover:bg-slate-100 hover:text-slate-800 dark:text-slate-400 dark:hover:bg-white/5 dark:hover:text-white"
                >
                  <FaRotateLeft />
                  Réinitialiser
                </button>
              )}
            </div>

            <div className="mt-5 grid gap-5 lg:grid-cols-2">
              {/* ---------------------------------------------------------- */}
              {/* DOJO                                                       */}
              {/* ---------------------------------------------------------- */}

              <div>
                <p className="mb-3 flex items-center gap-2 text-sm font-bold text-slate-700 dark:text-slate-200">
                  <FaMapMarkerAlt className="text-primary" />
                  Dojo
                </p>

                <div className="flex flex-wrap gap-2">
                  <FilterButton
                    active={selectedDojo === "all"}
                    onClick={() => setSelectedDojo("all")}
                  >
                    Tous les dojos
                  </FilterButton>

                  {DOJO_OPTIONS.map((dojo) => (
                    <FilterButton
                      key={dojo.id}
                      active={selectedDojo === dojo.id}
                      onClick={() => setSelectedDojo(dojo.id)}
                    >
                      {dojo.label}
                    </FilterButton>
                  ))}
                </div>
              </div>

              {/* ---------------------------------------------------------- */}
              {/* DISCIPLINE                                                 */}
              {/* ---------------------------------------------------------- */}

              <div>
                <p className="mb-3 flex items-center gap-2 text-sm font-bold text-slate-700 dark:text-slate-200">
                  <FaLayerGroup className="text-primary" />
                  Discipline
                </p>

                <div className="flex flex-wrap gap-2">
                  <FilterButton
                    active={selectedDiscipline === "all"}
                    onClick={() => setSelectedDiscipline("all")}
                  >
                    Toutes
                  </FilterButton>

                  {DISCIPLINE_OPTIONS.map((discipline) => (
                    <FilterButton
                      key={discipline.id}
                      active={selectedDiscipline === discipline.id}
                      onClick={() => setSelectedDiscipline(discipline.id)}
                    >
                      {discipline.label}
                    </FilterButton>
                  ))}
                </div>
              </div>
            </div>

            {/* ------------------------------------------------------------ */}
            {/* RÉSULTAT                                                     */}
            {/* ------------------------------------------------------------ */}

            <div className="mt-5 border-t border-slate-100 pt-4 dark:border-white/5">
              <p className="text-sm font-semibold text-slate-500 dark:text-slate-400">
                <strong className="text-slate-950 dark:text-white">
                  {filteredCourses.length}
                </strong>{" "}
                créneau
                {filteredCourses.length > 1 ? "x" : ""} affiché
                {filteredCourses.length > 1 ? "s" : ""}
              </p>
            </div>
          </div>
        </Reveal>

        {/* ================================================================ */}
        {/* PLANNING                                                         */}
        {/* ================================================================ */}

        <div className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-2 xl:grid-cols-3">
          {orderedDays.length === 0 && <EmptyState />}

          {orderedDays.map((day, index) => (
            <Reveal key={day} variant="zoom" delay={index * 70}>
              <DayCard
                day={day}
                courses={schedule[day]}
                isToday={day === todayLabel}
              />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
